// import React, { useState, useRef } from "react";
// import { Card, Col, Container, Row, Spinner } from "react-bootstrap";
// import axios from "axios";
// import { FaVideo } from "react-icons/fa"; // Icon import

// function Numberplat() {
//   const [videoFile, setVideoFile] = useState(null);
//   const [videoDetails, setVideoDetails] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [response, setResponse] = useState("");
//   const videoRef = useRef(null);

//   const handleFileChange = async (e) => {
//     const file = e.target.files[0];
//     if (file && file.type.startsWith("video/")) {
//       setVideoFile(file);

//       const videoURL = URL.createObjectURL(file);
//       const tempVideo = document.createElement("video");
//       tempVideo.src = videoURL;

//       tempVideo.onloadedmetadata = () => {
//         setVideoDetails({
//           name: file.name,
//           size: (file.size / (1024 * 1024)).toFixed(2) + " MB",
//           duration: tempVideo.duration.toFixed(2) + " sec",
//           type: file.type,
//         });
//       };

//       await uploadToBackend(file);
//     } else {
//       setVideoFile(null);
//       setVideoDetails(null);
//       alert("Please select a valid video file.");
//     }
//   };

//   const uploadToBackend = async (file) => {
//     setLoading(true);
//     try {
//       const formData = new FormData();
//       formData.append("video", file);

//       const response = await axios.post(
//         "https://visionemptrack.greymatterz.com/numberplate/process",
//         formData,
//         {
//           headers: {
//             "Content-Type": "multipart/form-data",
//           },
//         }
//       );

//       if (response) {
//         setResponse(response?.data);
//       }
//     } catch (error) {
//       console.error("Upload failed:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="container mt-5">
//       <Container>
//         <Row className="justify-content-center">
//           <Col md={10}>
//             <Card className="mb-4 shadow-sm">
//               <Card.Body className="text-center">
//                 <Card.Title className="fw-semibold mb-3 d-flex align-items-center justify-content-center gap-2">
//                   <FaVideo className="me-2" /> Upload Vehicle Video
//                 </Card.Title>

//                 <label
//                   htmlFor="upload-video"
//                   className="btn btn-outline-primary"
//                 >
//                   Select Video File
//                 </label>
//                 <input
//                   id="upload-video"
//                   type="file"
//                   accept="video/*"
//                   className="d-none"
//                   onChange={handleFileChange}
//                 />

//                 {loading && (
//                   <div className="mt-3">
//                     <Spinner animation="border" size="sm" className="me-2" />
//                     Processing video...
//                   </div>
//                 )}

//                 {response?.output && (
//                   <div className="mt-4">
//                     <h6>Processed Output:</h6>
//                     <video
//                       controls
//                       className="w-100"
//                       src={`https://visionemptrack.greymatterz.com/numberplate/output/${response.output}`}
//                     />
//                   </div>
//                 )}
//               </Card.Body>
//             </Card>
//           </Col>
//         </Row>
//       </Container>
//     </div>
//   );
// }

// export default Numberplat;

import React, { useEffect, useState, useMemo } from "react";
import "./style.css";

import {
  CourseListApi,
  fetchCameragrouplistingApi,
  GetAttendenceApi,
  getnumberPlates,
  ScheduleListApi,
  UseCaseMappingAttendence,
  UseCaseNumberPlateAttendence,
} from "../../api/api";
import { SkeletonCard } from "../../context/Customfunction";

function Numberplat() {
  const [loading, setLoading] = useState(false);
  const [sortBy, setSortBy] = useState("status");
  const [selectedCourseId, setSelectedCourseId] = useState();
  const [selectedRoomId, setSelectedRoomId] = useState("");
  const [selectedSemesterId, setSelectedSemesterId] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [camera, setCamera] = useState([]);
  const [cameraurl, setCameraurl] = useState([]);
  const [numberPlateData, setNumberPlateData] = useState([]);
  const itemsPerPage = 100;

  const [selectedDate, setSelectedDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  });

  const fetchUseCase = async () => {
    try {
      const data = await UseCaseNumberPlateAttendence();
      //console.log("data", data);
      if (data?.data?.status === true) {
        setCamera(data?.data?.data);
      }
    } catch (error) {
      //console.log("error", error);
    }
  };

  const fetchNmuberPlateData = async () => {
    try {
      const data = await getnumberPlates();
      // //console.log("================>00000", data?.data?.data);
      if (data?.data?.status === true) {
        setNumberPlateData(data?.data?.data);
      }
    } catch (error) {
      //console.log("error", error);
    }
  };

  useEffect(() => {
    fetchUseCase();
    fetchNmuberPlateData();
  }, []);

  const selectedId = (id) => {
    //console.log("camera", camera, id);
    const selectedCamera = camera.find((ele) => ele.camera_grp_id === id);
    //console.log("selectedCamera", selectedCamera);
    setCameraurl(selectedCamera);
  };

  const staticData = [
    {
      id: 1,
      src: "https://visionemptrack.greymatterz.com/numberplate/stream/number_plate_detection_685c00e1a178e25cf8560984",
      label: "Entry",
    },

    {
      id: 2,
      src: "https://visionemptrack.greymatterz.com/numberplate/stream/number_plate_detection_685c00a2a178e25cf8560983",
      label: "Exit",
    },
  ];

  return (
    <div className="d-flex fullHeightCst">
      {/* LEFT SECTION */}
      <div className="leftSection">
        <div className="titleFiltrer d-flex align-items-center p-4 border-bottom bg-white">
          <div className="col-xl-7">
            <h2 className="mb-0">Number Plate Detection</h2>
          </div>
          <div className="col-xl-5">
            <div className="d-flex gap-2">
              <select
                className="form-select"
                value={selectedSemesterId}
                onChange={(e) => selectedId(e.target.value)}
              >
                <option value="">Select Camera Group</option>
                {camera.map((item) => (
                  <option key={item.camera_grp_id} value={item.camera_grp_id}>
                    {item.camera_grp_name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        <div className="p-4">
          <h5 className="mb-3"> Room01</h5>
          <div className="cameraGrid gridClass1x3">
            {/* {cameraurl &&
              cameraurl?.cameras?.map((cam, idx) => (
                <div key={idx} className="image-box">
                  <img
                    src={cam.camera_live_url}
                    alt={cam.camera_live_url}
                    className="img-fluid rounded-top"
                  />
                  <div className="text-center py-2">{cam.label}</div>
                </div>
              ))} */}

            {staticData &&
              staticData?.map((cam, idx) => (
                <div key={idx} className="image-box">
                  <img
                    src={cam?.src}
                    alt="camera"
                    className="img-fluid rounded-top"
                  />
                  <div className="text-center py-2">{cam.label}</div>
                </div>
              ))}
          </div>
        </div>
      </div>

      {/* RIGHT SECTION */}
      <div className="rightSection bg-white border-start">
        <div className="titleFiltrer p-4 border-bottom">
          <h2 className="mb-2 mt-1">Details</h2>
        </div>

        <div className="p-3">
          <div className="border-top cstAttandanceTable">
            {loading ? (
              Array.from({ length: 5 }).map((_, i) => <SkeletonCard key={i} />)
            ) : (
              <>
                <table className="table cstTable table-sm mb-0">
                  <thead className="table-light sticky-top">
                    <tr>
                      <th style={{ width: "50px" }}>S.no</th>
                      <th>Number plate</th>
                      <th>Image</th>
                    </tr>
                  </thead>
                  <tbody>
                    {numberPlateData.map((ele, idx) => (
                      <tr key={ele?._id}>
                        <td>{String(idx + 1).padStart(2, "0")}</td>
                        <td>{ele?.number_detected}</td>
                        <td>
                          <img
                            src={`https://visionemptrack.greymatterz.com/numberplate/${ele?.image_path}`}
                            className="rounded-circle"
                            style={{
                              width: "50px",
                              height: "50px",
                              objectFit: "cover",
                            }}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                {/* {visibleData.length < sortedData.length && (
                  <div className="text-center my-3">
                    <button
                      className="btn btn-outline-primary"
                      onClick={() => setCurrentPage((prev) => prev + 1)}
                    >
                      Load More
                    </button>
                  </div>
                )} */}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Numberplat;
